if(!customElements.get('custom-faq')){
    class CustomFaq extends HTMLElement {
        constructor(){
            super();
    
            this.questions = this.querySelectorAll('custom-accordion');
            this.categoryWrapper = this.querySelector('.faq__category');
            this.categoryTitleMobile = this.querySelector('.faq__current-category span');
            
            this.init();
        }
    
        init(){
            var categories = [];
            this.questions.forEach((item, idx) => {
                if(!categories.includes(item.dataset.category.trim()) && item.dataset.category.trim() != ''){
                    categories.push(item.dataset.category.trim());
                }
            });
    
            // Add to category wrapper
            for(let idx=0; idx<categories.length; idx++){
                let elemA = document.createElement('a');
                elemA.setAttribute('href', '#');
                elemA.classList.add('category-item');
                elemA.setAttribute('data-category', categories[idx]);
                elemA.setAttribute('tabindex', '0');
                
                let elemSpan = document.createElement('span');
                elemSpan.innerHTML = categories[idx];
                elemA.appendChild(elemSpan);
    
                if(idx == 0){
                    elemA.setAttribute('data-active', 'true');
                    this.currentCategory = categories[idx];
                }else{
                    elemA.setAttribute('data-active', 'false');
                }
    
                this.categoryWrapper.appendChild(elemA);
            }
    
            this.loadCategory();
    
            // add event handler
            this.categories = this.querySelectorAll('.category-item');
            this.categories.forEach((item) => {
                item.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.currentCategory = e.currentTarget.dataset.category;
    
                    // close all opened accordion
                    this.questions.forEach((item) => {
                        item.closeAccordion();
                    })
    
                    this.loadCategory();
                })

                item.addEventListener('keydown', e => {
                    if(e.key === 'Enter'){
                        this.currentCategory = e.currentTarget.dataset.category;

                        // close all opened accordion
                        this.questions.forEach((item) => {
                            item.closeAccordion();
                        })
        
                        this.loadCategory();
                    }
                })
            })
        }
    
        loadCategory(){
            // display selected category
            this.querySelectorAll('.category-item').forEach((item) => {
                if(item.dataset.category == this.currentCategory){
                    item.setAttribute('data-active', 'true');
                }else{
                    item.setAttribute('data-active', 'false');
                }
            })
    
            // add category to the mobile title
            this.categoryTitleMobile.innerHTML = this.currentCategory;
    
            // display selected category items
            this.questions.forEach((item) => {
                if(item.dataset.category == this.currentCategory){
                    item.setAttribute('data-hidden', 'false');
                }else{
                    item.setAttribute('data-hidden', 'true');
                }
            })
        }
    }
    
    customElements.define('custom-faq', CustomFaq);
}
